<template>
  <div class="set">
    <van-nav-bar
      title="设置"
      @click-left="onClickLeft"
      left-arrow
    ></van-nav-bar>
    <div style="padding:0 10px;background:#fff;margin-top:10px;">
      <div
        style="display:flex;align-items:center;height: 50px;border-bottom:1px solid #eee;"
      >
        <img
          src="@/assets/images/touxiang.jpg"
          style="border-radius:50%; width:22px;height: 22px;margin-right:12px;"
          alt=""
        />
        <span v-if="userInfo" style="flex:1;color:#333;font-size:13px;">
          {{ userInfo.username }}</span
        >
      </div>
    </div>
    <div style="padding:0 10px;background:#fff;margin-top:10px;">
      <div
        @click="dianji(0)"
        style="display:flex;align-items:center;height: 50px;border-bottom:1px solid #eee;"
      >
        <img
          src="../../assets/images/zfmm.png"
          style="width:18px;height: 18px;margin-right:12px;"
          alt=""
        />
        <span style="flex:1;color:#333;font-size:13px;">修改支付密码</span>
        <img
          src="../../assets/images/yjt.png"
          style="width:13px;height: 13px;margin-right:12px;"
          alt=""
        />
      </div>
      <div
        @click="dianji(1)"
        style="display:flex;align-items:center;height: 50px;border-bottom:1px solid #eee;"
      >
        <img
          src="../../assets/images/dlmm.png"
          style="width:18px;height: 18px;margin-right:12px;"
          alt=""
        />
        <span style="flex:1;color:#333;font-size:13px;">修改登录密码</span>
        <img
          src="../../assets/images/yjt.png"
          style="width:13px;height: 13px;margin-right:12px;"
          alt=""
        />
      </div>
      <div
        @click="dianji(2)"
        style="display:flex;align-items:center;height: 50px;border-bottom:1px solid #eee;"
      >
        <img
          src="../../assets/images/qqhc.png"
          style="width:18px;height: 18px;margin-right:12px;"
          alt=""
        />
        <span style="flex:1;color:#333;font-size:13px;">清除缓存</span>
        <img
          src="../../assets/images/yjt.png"
          style="width:13px;height: 13px;margin-right:12px;"
          alt=""
        />
      </div>
    </div>
    <div
      style="width: 80%;margin-left:10%; line-height:45px;border-radius:6px; background:#1664FC;text-align:center;color:#fff;font-size:16px;font-weight:bold; margin-top:100px;"
      @click="dianji(3)"
    >
      退出登录
    </div>
  </div>
</template>

<script>
import { getMyUserInfo } from "@api/user";
import local from "@/utils/local";
export default {
  data() {
    return {
      userInfo: null
    };
  },
  created() {
    getMyUserInfo().then(res => {
      console.log(res.data, "oooooo");
      this.userInfo = res.data.data;
    });
  },
  methods: {
    dianji(e) {
      if (e == 0) {
        this.$router.push({
          path: "/PayPass"
        });
      } else if (e == 1) {
        this.$router.push({
          path: "/LoginPass"
        });
      } else if (e == 2) {
        this.$dialog.message("清理完毕");
      } else if (e == 3) {
        this.$store.commit("LOGOUT");
        let usernames = window.localStorage.getItem("zhanghao");
        let passwords = window.localStorage.getItem("mima");
        let fwq = window.localStorage.getItem("fwq");

        local.clear();
        window.localStorage.setItem("zhanghao", usernames);
        window.localStorage.setItem("mima", passwords);
        window.localStorage.setItem("fwq", fwq);

        this.$router.push({
          path: `/login`
        });
      }
    },
    onClickLeft() {
      this.$router.go(-1);
    }
  },
  components: {}
};
</script>
<style scoped lang="less">
.register_submit {
  width: 92%;
  margin: 0 auto;
  height: 50px;
  background: #1664FC;
  border-radius: 5px;
  margin-top: 20px !important;
  text-align: center;
  line-height: 50px;
  color: #ffffff;
  font-size: 16px;
}
.teamindeximg {
  width: 100%;
}

.teamtitle {
  background-color: #f6f6fe;
  font-size: 15px;
  display: flex;
  padding: 10px;
  box-sizing: border-box;
  align-items: center;
  width: calc(100% - 12px);
}

.teamnum {
  background-color: #067594;
  color: #fff;
  padding: 0 8px;
  border-radius: 20px;
  margin-left: 3px;
  font-size: 13px;
  height: 18px;
  line-height: 20px;
}

.teamli {
  border-bottom: 1px solid #f6f6f6;
  padding: 7px 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-sizing: border-box;

  font-size: 15px;
}

.teamlist {
  padding-right: 12px;
}

.teamlil {
  display: flex;
  align-items: center;
}

.teamlil img {
  width: 50px;
  height: 50px;
  object-fit: cover;
  border-radius: 100%;
  margin-right: 20px;
}
/deep/ .van-nav-bar .van-icon {
  color: #333;
}

/deep/ #all {
  width: 780px;
  padding: 100px 32px;
  background: #fff;
}
</style>
